/// <amd-module name="TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Sources/SSHPublicKeysDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { PublicKeyModel, PublicKeysCredentialsModel } from "TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Contracts";

const getInitialDataProvider = "ms.vss-admin-web.organization-admin-overview-data-provider";
const getFingerprintDataProvider = "ms.vss-admin-web.profile-sshpublickeys-view-data-provider";
const getCredentialsDataProvider = "ms.vss-admin-web.ssh-public-keys-data-provider";

export function getInitialSSHData(pageContext: IVssPageContext): Promise<any | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    // Using ignoreCache = true to make sure we get the latest data from the server on refresh.
    return contributionService.getDataAsync<{ [accountId: string]: string }>(getInitialDataProvider, {}, true).then(result => {
        return result;
    });
}

export function getFingerprintData(pageContext: IVssPageContext, authorizationId: string): Promise<any | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    // Using ignoreCache = true to make sure we get the latest data from the server on refresh.
    return contributionService.getDataAsync<PublicKeyModel>(getFingerprintDataProvider, { authorizationId: authorizationId }, true).then(result => {
        return result;
    });
}

export function getCredentialsModel(pageContext: IVssPageContext): Promise<any | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    // Using ignoreCache = true to make sure we get the latest data from the server on refresh.
    return contributionService.getDataAsync<PublicKeysCredentialsModel>(getCredentialsDataProvider, {}, true).then(result => {
        return result;
    });
}